import React from "react";
import { Grid } from "@material-ui/core/";
import Button from "@material-ui/core/Button";
import "./about.css";
import * as data from "../performance-tracker-template/data-toload.json";
import { Gauge } from "../visualisations/gauge";
import { Sunburst } from "../visualisations/sunburst";
import { BarChart } from "../visualisations/barchart";
import { useHistory } from "react-router-dom";
import img_legend from "../img/legend_1.png";
import "./benchmarking.css";
import questionScoreData from "./questionScore.json";
import { BarChartGoogle } from "../visualisations/barChartGoogle";
interface IProps {
  organisation: string;
}
export const BenchmarkingPage: React.FC<IProps> = (props: IProps) => {
  const history = useHistory();
  const dataStyles: { [tab: string]: EnvTempStyles } = data.envTemplateStyles;
  var scoresUnListed: {
    [category: string]: {
      [subCategory: string]: {
        index: number;
        question: string;
        score: number;
        maximumScore: number;
      }[];
    };
  } = questionScoreData;
  var quants = [
    {
      "SUSTAINABLE ENERGY & CARBON REDUCTION": [
        {
          "Carbon Reduction Planning & Delivery": [
            {
              index: 1,
              question: "Carbon Management Plan",
              score: 3,
              maximumScore: 5,
            },
            {
              index: 2,
              question: "Delivery team",
              score: 2,
              maximumScore: 2,
            },
            {
              index: 3,
              question: "Publishing strategy",
              score: 0.5,
              maximumScore: 1,
            },
          ],
        },
        {
          "Energy Efficiency Measures": [
            {
              index: 4,
              question: "Low carbon heating",
              score: 2,
              maximumScore: 2,
            },
            {
              index: 5,
              question: "LED lighting",
              score: 2,
              maximumScore: 2,
            },
            {
              index: 6,
              question: "Heat & ventilation",
              score: 1.8,
              maximumScore: 2,
            },
            {
              index: 7,
              question: "Building fabric",
              score: 2,
              maximumScore: 3,
            },
            {
              index: 8,
              question: "Insulation of buildings",
              score: 0,
              maximumScore: 1,
            },
            {
              index: 9,
              question: "Natural lighting",
              score: 1,
              maximumScore: 1,
            },
          ],
        },
        {
          "Production In Fossil Fuel Consumption": [
            {
              index: 10,
              question: "PV",
              score: 2.8,
              maximumScore: 5,
            },
            {
              index: 11,
              question: "Energy Provision from renewables",
              score: 1,
              maximumScore: 5,
            },
            {
              index: 12,
              question: "Carbon emissions from energy consumption",
              score: 1.5,
              maximumScore: 5,
            },
          ],
        },
      ],
    },
    {
      "CLEAN AIR": [
        {
          "Electrical Charge Points": [
            {
              index: 13,
              question: "Ratio of electrical vehicle (EV) charge points",
              score: 2,
              maximumScore: 2,
            },
          ],
        },
        {
          "Schemess to Incentivise & Disincentivise": [
            {
              index: 14,
              question: "Incentive schemes",
              score: 2,
              maximumScore: 2,
            },
            {
              index: 15,
              question: " Disincentivizing schemes",
              score: 0,
              maximumScore: 1,
            },
            {
              index: 16,
              question: "Eco-safe driver training",
              score: 0,
              maximumScore: 0.5,
            },
          ],
        },
        {
          "Encourage Low Emission Vehicles": [
            {
              index: 17,
              question: "Ultra–low emission concentration (commuting fleet)",
              score: 0.1,
              maximumScore: 1,
            },
            {
              index: 18,
              question:
                "Ultra–low emission concentration (goods and services fleet)",
              score: 0.6,
              maximumScore: 2,
            },
          ],
        },
      ],
    },
    {
      ENVIRONMENT: [
        {
          "Establishing Green Infrastructure": [
            {
              index: 19,
              question: "Quality of biodiverse external environments",
              score: 0,
              maximumScore: 1,
            },
            {
              index: 20,
              question: "Green infrastructure management",
              score: 1,
              maximumScore: 1,
            },
            {
              index: 21,
              question: "Tree planting",
              score: 1,
              maximumScore: 1,
            },
          ],
        },
        {
          "Support % Management of Green Infrastructure": [
            {
              index: 22,
              question: "Green wall/roof project",
              score: 1,
              maximumScore: 2,
            },
            {
              index: 23,
              question: "Connectivity with green corridor",
              score: 1,
              maximumScore: 1,
            },
          ],
        },
      ],
    },
    {
      "WASTE & WATER MANAGEMENT": [
        {
          "Adoption of sustainable waste models": [
            {
              index: 24,
              question: "Waste segregation",
              score: 3,
              maximumScore: 3,
            },
            {
              index: 25,
              question: "Waste stream auditing",
              score: 1,
              maximumScore: 3,
            },
            {
              index: 26,
              question: "Waste management training",
              score: 0,
              maximumScore: 2,
            },
          ],
        },
        {
          "Plastic Management and Procurement Strategies": [
            {
              index: 27,
              question: "Elimination of single–use plastic",
              score: 0,
              maximumScore: 1,
            },
            {
              index: 28,
              question: "Sustainable procurement strategy",
              score: 0,
              maximumScore: 3,
            },
          ],
        },
        {
          "Water consumption controls": [
            {
              index: 29,
              question: "Deployment of water–saving measures",
              score: 2,
              maximumScore: 2,
            },
            {
              index: 30,
              question: "Water consumption and leakage monitoring",
              score: 3,
              maximumScore: 3,
            },
            {
              index: 31,
              question: "Water efficiency training",
              score: 0,
              maximumScore: 1,
            },
          ],
        },
      ],
    },
    {
      "SUSTAINABLE TRAVEL": [
        {
          "Enhance Adoption of Active and Public Modes of Travel": [
            {
              index: 32,
              question:
                "Ratio of employees walking, cycling & working from home",
              score: 1,
              maximumScore: 5,
            },
            {
              index: 33,
              question: "Ratio of employees using public transport",
              score: 0.2,
              maximumScore: 3,
            },
            {
              index: 34,
              question: "Low emission transport facilities",
              score: 2,
              maximumScore: 2,
            },
            {
              index: 35,
              question: "Car sharing scheme",
              score: 0.3,
              maximumScore: 1,
            },
          ],
        },
        {
          "Supporting Smart Travel": [
            {
              index: 36,
              question: "Travel plan",
              score: 0,
              maximumScore: 2,
            },
            {
              index: 37,
              question: "Method of transport for business trips",
              score: 1.5,
              maximumScore: 2,
            },
            {
              index: 38,
              question: "Flight avoidance",
              score: 1,
              maximumScore: 1,
            },
            {
              index: 39,
              question: "Journey optimisation",
              score: 1.5,
              maximumScore: 2,
            },
          ],
        },
      ],
    },
  ];
  var questionStyles: { [category: string]: EnvTempStyles } = {
    "SUSTAINABLE ENERGY & CARBON REDUCTION": {
      themeBackground: "#c14c4a",
      subThemeBackground: "#e99889",
      themeItemBackground: "",
      color: "",
      img: "",
    },
    "CLEAN AIR": {
      themeBackground: "#198df1",
      subThemeBackground: "#83daff",
      themeItemBackground: "",
      color: "",
      img: "",
    },
    ENVIRONMENT: {
      themeBackground: "#3d9732",
      subThemeBackground: "#8dd380",
      themeItemBackground: "",
      color: "",
      img: "",
    },
    "WASTE & WATER MANAGEMENT": {
      themeBackground: "#5c5446",
      subThemeBackground: "#b39a5b",
      themeItemBackground: "",
      color: "",
      img: "",
    },
    "SUSTAINABLE TRAVEL": {
      themeBackground: "#c7ac37",
      subThemeBackground: "#fcd743",
      themeItemBackground: "",
      color: "",
      img: "",
    },
  };
  var placeHolders = {
    "Sparse Measures": {
      lowerLimit: 0,
      upperLimit: 30,
      style: {
        themeBackground: "#ec697a",
        subThemeBackground: "#e99889",
        themeItemBackground: "",
        color: "",
        img: "",
      },
    },
    "Scope For Improvement": {
      lowerLimit: 30,
      upperLimit: 50,
      style: {
        themeBackground: "#fcca00",
        subThemeBackground: "#fcca00",
        themeItemBackground: "",
        color: "",
        img: "",
      },
    },
    Satisfactory: {
      lowerLimit: 50,
      upperLimit: 70,
      style: {
        themeBackground: "#a8d28b",
        subThemeBackground: "#a8d28b",
        themeItemBackground: "",
        color: "",
        img: "",
      },
    },
    Good: {
      lowerLimit: 70,
      upperLimit: 90,
      style: {
        themeBackground: "#b4c701",
        subThemeBackground: "#b4c701",
        themeItemBackground: "",
        color: "",
        img: "",
      },
    },
    Outstanding: {
      lowerLimit: 90,
      upperLimit: 100,
      style: {
        themeBackground: "#538330",
        subThemeBackground: "#538330",
        themeItemBackground: "",
        color: "",
        img: "",
      },
    },
  };

  var barChartCategoriesGoogle: {
    [category: string]: {
      subCategories: { [subcategory: string]: Array<string | number>[] };
      color: string;
    };
  } = {};

  var barChartSubCategoriesGoogle: {
    [subcategory: string]: Array<string | number>[];
  } = {};
  Object.keys(scoresUnListed).forEach((category: string) => {
    Object.keys(scoresUnListed[category]).forEach((subCategory: string) => {
      var questionScores: Array<string | number>[] = [
        ["question", "score", "max"],
      ];
      scoresUnListed[category][subCategory].forEach((scoreInfo) => {
        var question = scoreInfo.index.toString() + ". " + scoreInfo.question;
        var score = scoreInfo.score;
        var max = scoreInfo.maximumScore - scoreInfo.score;
        questionScores.push([question, score, max]);
      });
      barChartSubCategoriesGoogle[subCategory] = questionScores;
    });
    barChartCategoriesGoogle[category] = {
      subCategories: barChartSubCategoriesGoogle,
      color: questionStyles[category].themeBackground,
    };
    barChartSubCategoriesGoogle = {};
  });
  var gaugeProps = {
    year: 2019,
    value: 55,
    sections: placeHolders,
  };
  var gaugeProps2021 = {
    year: 2020,
    value: 55,
    sections: placeHolders,
  };

  var sunburstProps = {
    questionResults: quants,
    questionStyles: questionStyles,
    sections: placeHolders,
  };

  return (
    <div>
      <h2>Green City Charter Year Comparison</h2>
      <Grid direction="row" container spacing={9} justify="space-between">
        <Grid item lg={6} md={12}>
          <div className="benchmark_box">
            <div className="benchmark_box_title">
              <span>LAST YEAR</span>
            </div>
            <div className="benchmark_top_chart">
              <Sunburst data={sunburstProps}></Sunburst>
            </div>
          </div>
        </Grid>
        <Grid item lg={6} md={12}>
          <div className="benchmark_box">
            <div className="benchmark_box_title">
              <span>CURRENT YEAR</span>
            </div>
            <div className="benchmark_top_chart">
              <Sunburst data={sunburstProps}></Sunburst>
            </div>
          </div>
        </Grid>
        <Grid xs={12} style={{ textAlign: "center" }}>
          <img src={img_legend} style={{ width: "95%" }} />
        </Grid>
      </Grid>

      <div className="h2_benchmark">
        Green City Charter Organisation Comparison
      </div>

      <Grid direction="row" container spacing={9} justify="space-between">
        <Grid item lg={6} md={12}>
          <div className="benchmark_box">
            <div className="benchmark_box_title">
              <span color="red">{props.organisation}'s </span>{" "}
              <span className="benchmark_gauge_title">Score</span>
            </div>
            <div className="benchmark_box_chart_gauge">
              <Gauge data={gaugeProps}></Gauge>
            </div>
            <div className="benchmark_chart_zoom">
              <Sunburst data={sunburstProps}></Sunburst>
            </div>
            <div style={{ padding: 10 }}>
              {Object.keys(barChartCategoriesGoogle).map((category, i) => {
                return (
                  <div key={i}>
                    <div className="benchmark_barchart_title_1">{category}</div>

                    <Grid container direction="column">
                      {Object.keys(
                        barChartCategoriesGoogle[category].subCategories
                      ).map((subCategory, j) => {
                        return (
                          <Grid item key={j}>
                            <div className="benchmark_barchart_title_2">
                              {subCategory}
                            </div>
                            <BarChartGoogle
                              data={
                                barChartCategoriesGoogle[category]
                                  .subCategories[subCategory]
                              }
                              color={barChartCategoriesGoogle[category].color}
                            ></BarChartGoogle>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </div>
                );
              })}
            </div>
          </div>
        </Grid>
        <Grid item lg={6} md={12}>
          <div className="benchmark_box">
            <div className="benchmark_box_title">
              <span className="benchmark_gauge_title2">
                Average organisation score
              </span>
            </div>
            <div className="benchmark_box_chart_gauge">
              <Gauge data={gaugeProps2021}></Gauge>
            </div>
            <div className="benchmark_chart_zoom">
              <Sunburst data={sunburstProps}></Sunburst>
            </div>
            <div style={{ padding: 10 }}>
              {Object.keys(barChartCategoriesGoogle).map((category, i) => {
                return (
                  <div key={i}>
                    <div className="benchmark_barchart_title_1">{category}</div>

                    <Grid container direction="column">
                      {Object.keys(
                        barChartCategoriesGoogle[category].subCategories
                      ).map((subCategory, j) => {
                        return (
                          <Grid item key={j}>
                            <div className="benchmark_barchart_title_2">
                              {subCategory}
                            </div>
                            <BarChartGoogle
                              data={
                                barChartCategoriesGoogle[category]
                                  .subCategories[subCategory]
                              }
                              color={barChartCategoriesGoogle[category].color}
                            ></BarChartGoogle>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </div>
                );
              })}
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};
